import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid,
} from "@mui/material";

import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import api from "../../api/axios"; // ✅ Utilisation de l’instance personnalisée

const Bills = () => {
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [billFormData, setBillFormData] = useState({
    Vendor: "",
    Amount: "",
    DueDate: "",
    Status: "",
  });

  useEffect(() => {
    const fetchBills = async () => {
      setLoading(true);
      try {
        const response = await api.get("/quickbooks/bills/");
        console.log("Bills: ", response.data);
        setBills(response.data.bills);
      } catch (err) {
        console.error("❌ Failed to fetch bills:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchBills();
  }, []);

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setBillFormData({ Vendor: "", Amount: "", DueDate: "", Status: "" });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBillFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleBillSubmit = async () => {
    try {
      await api.post("/quickbooks/bills/", billFormData);
      setBills((prev) => [...prev, billFormData]);
      handleDialogClose();
    } catch (err) {
      console.error("❌ Failed to submit bill:", err);
    }
  };

  const columns = [
    { Header: "Vendor", accessor: "Vendor", align: "left" },
    { Header: "Amount", accessor: "Amount", align: "left" },
    { Header: "Due Date", accessor: "DueDate", align: "left" },
    { Header: "Status", accessor: "Status", align: "left" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={handleDialogOpen}>
            Add Bill
          </Button>
        </Grid>
        <MDBox pt={3}>
          <DataTable table={{ columns, rows: bills }} isLoading={loading} noEndBorder />
        </MDBox>
      </MDBox>
      <Footer />
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Add Bill</DialogTitle>
        <DialogContent>
          <TextField
            label="Vendor"
            name="Vendor"
            value={billFormData.Vendor}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Amount"
            name="Amount"
            value={billFormData.Amount}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Due Date"
            name="DueDate"
            type="date"
            value={billFormData.DueDate}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Status"
            name="Status"
            value={billFormData.Status}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button onClick={handleBillSubmit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
};

export default Bills;
